import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-maintenance-alerts',
  templateUrl: './manage-maintenance-alerts.component.html',
  styleUrls: ['./manage-maintenance-alerts.component.scss']
})
export class ManageMaintenanceAlertsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
